// extracted by mini-css-extract-plugin
module.exports = {"container":"premium-PlansOverviewSummary__container--1AMGs","title":"premium-PlansOverviewSummary__title--1E4lZ","description":"premium-PlansOverviewSummary__description--zyeq9"};